import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export type WorkspaceDetailHeaderProps = {
  name: string;
  color: string;
  onBack: () => void;
};

export const WorkspaceDetailHeader = ({
  name,
  color,
  onBack
}: WorkspaceDetailHeaderProps) => (
  <div className="flex w-full shrink-0 justify-center border-gray-200 border-b border-solid p-8">
    <div className="flex w-full max-w-7xl items-center gap-3">
      <Button
        aria-label="Back to workspaces"
        onClick={onBack}
        size="icon"
        variant="ghost"
      >
        <ArrowLeft className="h-4 w-4" />
      </Button>
      <div className="flex items-center gap-3">
        <div
          className="h-5 w-5 shrink-0 rounded-full"
          style={{ backgroundColor: color }}
        />
        <div>
          <h1 className="text-pretty text-2xl">{name}</h1>
          <p className="text-muted-foreground text-sm">
            Workspace details and configuration
          </p>
        </div>
      </div>
    </div>
  </div>
);
